export interface LogMessage {
    type: string;
    date: Date;
    message: string;
}
const MAX_LOG_MESSAGES = 500;

const logMessages: LogMessage[] = [];

export const initLoggingCapture = (production = true) => {
    if (window.console && console.log) {
        const nativeLog = console.log;
        const nativeError = console.error;
        const nativeWarn = console.warn;
        const nativeInfo = console.info;

        let saveLogMessage = (type: string, ...args: any[]) => {
            try {
                const message = args
                    .map((x) => {
                        if (typeof x === 'string') {
                            return x;
                        }

                        if (typeof x === 'object') {
                            return JSON.stringify(x, null, 4);
                        }

                        return x?.toString();
                    })
                    .join(', ');
                logMessages.push({ type, date: new Date(), message });
            } catch (e) {
                // Swallow the error if something goes wrong
                logMessages.push({ type, date: new Date(), message: 'Error formatting log message: ' + (e?.message ?? e) });
            }

            if (logMessages.length > MAX_LOG_MESSAGES) {
                logMessages.splice(0, logMessages.length - MAX_LOG_MESSAGES);
            }
        };

        if (production) {
            console.error = function () {
                var args = arguments;
                saveLogMessage('error', ...args);
                nativeError.apply(console, args);
            };

            console.warn = function () {
                var args = arguments;
                saveLogMessage('warn', ...args);
                nativeWarn.apply(console, args);
            };

            console.info = function () {
                var args = arguments;
                saveLogMessage('info', ...args);
                nativeInfo.apply(console, args);
            };

            console.log = function () {
                var args = arguments;
                saveLogMessage('log', ...args);
                nativeLog.apply(console, args);
            };
        }

        // console.log = Function.prototype.bind.call(saveLogMessage('log', nativeLog), console);
        // console.error = Function.prototype.bind.call(saveLogMessage('error', nativeError), console);
        // console.info = Function.prototype.bind.call(saveLogMessage('info', nativeInfo), console);
        // console.warn = Function.prototype.bind.call(saveLogMessage('warn', nativeWarn), console);
    }
};

export const clearLog = () => {
    logMessages.splice(0, logMessages.length);
};

export const getLog = () => {
    return logMessages;
};

(window as any).getLog = getLog;
(window as any).clearLog = clearLog;
